import { createStore, combineReducers } from 'redux'
import { setproject, setscroll } from '../action/action';

const combiner = combineReducers({
    scrollstate: setscroll,
    initialProject: setproject
});

const store = createStore(combiner)

export default store;